import React from 'react';
import { Button } from 'antd';
import { useUpdate } from 'context/ResourceProvider/hooks/useUpdate';

export const DeleteAction = (props) => {
  const { id, notificationSuccess, notificationError, ...buttonProps } = props;
  const { mutate } = useUpdate({
    resource: 'quality-requirements/templates',
    id,
    meta: {
      method: 'delete',
    },
  });

  const handleDelete = async () => {
    try {
      await mutate();
      if (notificationSuccess) {
        notificationSuccess();
      }
    } catch (error) {
      console.error('Error deleting template:', error);
      if (notificationError) {
        notificationError();
      }
    }
  };

  return <Button onClick={handleDelete} {...buttonProps} />;
};
